// components/PwaPromptBanner.js
import React, { useEffect, useState } from "react";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.sriponnachiammantemples.test"; // replace with your actual app ID


const PwaPromptBanner = () => {
    const [showBanner, setShowBanner] = useState(false);
    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        const isInStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
        const isDismissed = localStorage.getItem("pwaPromptDismissed") === "true";
        const ua = window.navigator.userAgent.toLowerCase();
        const isiOS = /iphone|ipad|ipod/.test(ua);
        const isAndroid = /android/.test(ua);

        if (!isInStandalone && !isDismissed && (isiOS || isAndroid)) {
            setShowBanner(true);
            setIsIOS(isiOS);
        }
    }, []);

    const handleDismiss = () => {
        localStorage.setItem("pwaPromptDismissed", "true");
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div style={{
            backgroundColor: "#fffae5",
            padding: "10px 20px",
            textAlign: "center",
            borderBottom: "1px solid #ddd",
            position: "sticky",
            top: 0,
            zIndex: 9999
        }}>
            {isIOS ? (
                <div>
                    <strong>iOS Users:</strong> Add this app to your home screen for the best experience.
                    <div style={{ marginTop: "5px" }}>
                        Tap <span style={{ fontWeight: "bold" }}>&#x1f50d; Share</span> then Add to Home Screen
                    </div>
                </div>
            ) : (
                <div>
                    <strong>Get our App:</strong> Download from Play Store for a better experience.
                    <div style={{ marginTop: "5px" }}>
                        <a
                            href={PLAY_STORE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                background: "#4CAF50",
                                color: "white",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                textDecoration: "none"
                            }}
                        >
                            Open in Play Store
                        </a>
                    </div>
                </div>
            )}
            <div style={{ marginTop: "5px" }}>
                <button
                    onClick={handleDismiss}
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "#555",
                        cursor: "pointer",
                        fontSize: "14px",
                        marginTop: "5px"
                    }}
                >
                    Dismiss
                </button>
            </div>
        </div>
    );
};

export default PwaPromptBanner;
